<div>
  @if ($globalBanner()) {
    <div [margin]="'small'" [margin-direction]="'bottom'">
      <app-global-inline-banner />
    </div>
  }
  <div class="elz-flex-aligned-space-between">
    <div>
      @for (crumb of $breadcrumbs(); track crumb.name; let isLast = $last) {
        <a [routerLink]="crumb.path" data-testid="page-layout-breadcrumb-navigation-button">
          {{ crumb.name }}
        </a>
        @if (!isLast) {
          /
        }
      }
    </div>

    <div class="elz-flex-centered">
      @if (
        (router.url | excludedUrls) && $application() === ApplicationNames.Elementz && !$isOutsideElement()
      ) {
        <mat-form-field subscriptSizing="dynamic" class="elz-margin__right--medium">
          <mat-label>{{ $entity() | titlecase }}</mat-label>

          <input
            type="text"
            matInput
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            [placeholder]="'Search ' + $entity()"
            (focus)="onFocus()"
            (blur)="onBlur()"
            data-testid="entity-search-input"
          />

          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayInstallation"
            (optionSelected)="changeInstallation($event.option.value)"
          >
            @for (installation of $filteredInstallations(); track installation.componentId) {
              <mat-option [value]="installation" data-testid="entity-option">
                {{ installation.name }} - {{ installation.description }}
              </mat-option>
            }
          </mat-autocomplete>

          @if ($selectedInstallation()) {
            <button
              mat-icon-button
              matSuffix
              aria-label="Clear selection"
              (click)="changeInstallation(null)"
              data-testid="entity-close"
            >
              <mat-icon matSuffix>close</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if ($application() === ApplicationNames.Elementz && $userHasElementsAccess()) {
        <button
          #notificationsButton
          mat-icon-button
          class="elz-margin__right--small"
          (click)="$includeInApp() ? openNotificationsDialog() : openNotifications()"
          data-testid="notifications-button"
        >
          @if ($includeInApp()) {
            <mat-icon [matBadge]="$totalUnread() | noZeroFormatter | badgeNumber" aria-hidden="false">
              {{ notificationsIcon }}
            </mat-icon>
          } @else {
            <mat-icon>
              {{ notificationsOffIcon }}
            </mat-icon>
          }
        </button>
      }

      <button
        mat-stroked-button
        [matMenuTriggerFor]="quickLaunch"
        class="elz-margin__right--small"
        data-testid="quick-launch"
      >
        <mat-icon>{{ rocketLaunchIcon }}</mat-icon>
        Quick Launch
      </button>

      <a mat-icon-button [href]="helpDeskLink" target="_blank" data-testid="contact-support">
        <mat-icon>{{ contactSupportIcon }}</mat-icon>
      </a>
    </div>
  </div>
</div>

<mat-menu #quickLaunch>
  <div>
    <div class="elz-flex-aligned-right elz-icon-button__density--small">
      <button mat-icon-button class="elz-margin__right--x-small" data-testid="quick-launch-close">
        <mat-icon>{{ closeIcon }}</mat-icon>
      </button>
    </div>
    <div class="elz-padding__left--small elz-padding__right--small elz-padding__bottom--small">
      <div class="elz-flex">
        <mat-icon class="elz-margin__right--x-small elz-font-colour--accent">
          {{ accountCircleIcon }}
        </mat-icon>
        <div>
          {{ $user()?.name }}
          <div class="elz-font-size--medium">
            {{ $user()?.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-divider />
  @if ($application() !== ApplicationNames.Admin) {
    <button
      mat-menu-item
      (click)="navigateToAdmin()"
      [disabled]="!$isUserAdmin()"
      [matTooltip]="
        !$isUserAdmin() ? 'You don\'t have access to this, please contact your administrator' : null
      "
      data-testid="admin-link"
    >
      <mat-icon>{{ settingsAccountBoxIcon }}</mat-icon>
      Administration
    </button>
  }
  @if ($application() !== ApplicationNames.Elementz) {
    <button mat-menu-item (click)="navigateHome()" data-testid="home-link">
      <mat-icon>{{ homeIcon }}</mat-icon>
      Elementz
    </button>
  }
  <button mat-menu-item (click)="signOut()" data-testid="logout">
    <mat-icon>{{ logOutIcon }}</mat-icon>
    Sign Out
  </button>
  <mat-divider />
  <div class="elz-padding--small elz-font-size--small" data-testid="version-number">
    Version: {{ version.versionNumber }}
  </div>
</mat-menu>
